import yup from 'utils/yup';

// Types
export interface JobOption {
  id: string | number;
  name: string;
}

export interface TaskOption {
  id: string | number;
  name: string;
}

export interface ReportFormData {
  date_range: [Date | null, Date | null];
  job_ids: JobOption[] | null;
  task_id: TaskOption | null;
}

export const initialReportByJobsTotalOnlyFormData: ReportFormData = {
  date_range: [null, null],
  job_ids: [],
  task_id: null,
};

export const reportByJobsTotalOnlyValidationSchema = yup.object().shape({
  date_range: yup
    .array()
    .of(yup.date().nullable())
    .test('date-range', 'Both start and end dates are required', value => {
      return !!(value && value[0] && value[1]);
    })
    .required('Date range is required'),
});
